const e = "adyen-pe-payouts-overview-container";
export {
  e as BASE_CLASS
};
